import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { InfoPage, PortalOneColumnLayout } from 'components/PortalStructure';
import { InfoPageHeaderSection, InfoPageHeaderTitle, InfoPageSection, InfoPageTitle1 } from 'components';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router';
const { asyncConnect } = require('redux-connect');

interface IProps {
	baseUrlClient?: string;
}

@asyncConnect([
	{
		promise: () => {
			return Promise.all([]);
		},
	},
])
@connect((state: IStore) => ({
	baseUrlClient: state.fetchDefault.baseUrlClient,
}))
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class PortalDeleteAccountHR extends React.Component<IProps, any> {
	public render() {
		const siteTitle = 'Brisanje računa';
		const siteDescription =
			'Kada izbrišeš svoj račun, svi će tvoji podaci biti trajno uklonjeni. Iz sigurnosnih razloga ne možemo izbrisati tvoj račun umjesto tebe. Ako želiš zatražiti brisanje, morat ćeš se prijaviti na svoj račun.';
		const siteKeywords = 'Delete account keywords';
		const siteImage = this.props.baseUrlClient + '/images/logo.png';
		const siteUrl = this.props.baseUrlClient + '/deleteaccount/hr';

		return (
			<PortalOneColumnLayout>
				<InfoPage>
					<InfoPageHeaderSection>
						<img src={require('../../../containers/Html/icons/symbol1.svg')} alt="glossiq icon" />
						<InfoPageHeaderTitle>Brisanje računa</InfoPageHeaderTitle>
					</InfoPageHeaderSection>
					<hr />
					<InfoPageSection>
						<p>
							Kada izbrišeš svoj račun, svi će tvoji podaci biti trajno uklonjeni. Iz sigurnosnih razloga ne možemo
							izbrisati tvoj račun umjesto tebe. Ako želiš zatražiti brisanje, morat ćeš se prijaviti na svoj račun.
						</p>

						<InfoPageTitle1>Ako želiš zatražiti trajno brisanje svog računa: </InfoPageTitle1>

						<ul>
							<li>
								Prijavi se na svoj račun: Posjeti web stranicu Glossiq.com na svom računalu ili otvori mobilnu
								aplikaciju i prijavi se koristeći svoje korisničko ime i lozinku.
							</li>

							<li>
								Pronađi postavke računa: Na računalu klikni svoju profilnu sliku u gornjem desnom kutu zaslona, zatim
								klikni <Link to="/account">Postavke</Link>. U mobilnoj aplikaciji klikni na Profil u desnom gornjem kutu
								ekrana i zatim klikni na Račun.
							</li>

							<li>
								Pristupi opciji za brisanje svog računa: Pomakni se prema dolje do odjeljka Deaktiviraj račun i klikni
								na gumb "Deaktiviraj moj račun".
							</li>

							<li>Potvrdi svoju namjeru brisanja: Ako si siguran/sigurna u brisanje računa, klikni na gumb 'Dalje'.</li>

							<li>
								Pošalji povratne informacije: Navedi razlog svoje odluke ili odaberi 'Ostalo' ako to ne želiš
								podijeliti, a zatim klikni gumb 'Deaktiviraj moj račun' za početak postupka brisanja.
							</li>

							<li>Provjeri svoju e-poštu: Primit ćeš poruku potvrde koja potvrđuje brisanje tvog računa.</li>
						</ul>

						<p>
							Nakon 7 dana od zahtjeva za brisanje tvog računa, tvoj račun i svi tvoji podaci bit će trajno izbrisani i
							neće ih biti moguće vratiti.
						</p>
					</InfoPageSection>
				</InfoPage>
				<Helmet
					title={siteTitle}
					link={[{ rel: 'canonical', href: siteUrl }]}
					meta={[
						{ property: 'og:title', content: siteTitle },
						{ property: 'og:image', content: siteImage },
						{ property: 'og:description', content: siteDescription },
						{ property: 'og:url', content: siteUrl },
						{ name: 'title', content: siteTitle },
						{ name: 'description', content: siteDescription },
						{ name: 'keywords', content: siteKeywords },
					]}
				/>
			</PortalOneColumnLayout>
		);
	}
}

export { PortalDeleteAccountHR };
